<template>
  <PaginaAdministrar
    titulo="Saldo Estoque - Especiais"
    subtitulo="Estoque de importação por contrato, cota, embarque e lote"
    v-model:filtros-abertos="filtrosAbertos"
    :total-itens="paginacao.TotalCount"
    :itens-por-pagina="paginacao.PageSize"
    :pagina-atual="paginacao.CurrentPage"
    :mostrar-botao-adicionar="false"
    @mudar-pagina="mudarPagina"
    @mudar-tamanho-pagina="mudarTamanhoPagina"
    @atualizar="aplicarFiltros"
  >
    <template #acoes="{ toggleFiltros }">
      <button class="btn btn-dark" @click="toggleFiltros">
        <i class="bi bi-filter-lg me-2"></i> Filtros
      </button>
    </template>

    <template #filtros>
      <div class="row g-3 align-items-end">
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroProdutos"
            label="Produtos"
            v-model="filtros.idsProdutos"
            v-model:itens-selecionados="filtros.produtosSelecionados"
            :configuracao-busca="configBuscaProduto"
            placeholder="Digite nome ou SKU..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroContratos"
            label="Contratos"
            v-model="filtros.idsContratos"
            v-model:itens-selecionados="filtros.contratosSelecionados"
            :configuracao-busca="configBuscaContrato"
            placeholder="Nº do contrato..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroCotas"
            label="Purchase Orders"
            v-model="filtros.idsPurchaseOrders"
            v-model:itens-selecionados="filtros.purchaseOrdersSelecionados"
            :configuracao-busca="configBuscaPurchaseOrder"
            placeholder="Referência da PO..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroEmbarques"
            label="Embarques"
            v-model="filtros.idsEmbarques"
            v-model:itens-selecionados="filtros.embarquesSelecionados"
            :configuracao-busca="configBuscaEmbarque"
            placeholder="ID do embarque..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroFornecedores"
            label="Fornecedores"
            v-model="filtros.idsFornecedores"
            v-model:itens-selecionados="filtros.fornecedoresSelecionados"
            :configuracao-busca="configBuscaFornecedor"
            placeholder="Nome ou CNPJ..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroProdutores"
            label="Produtores"
            v-model="filtros.idsProdutores"
            v-model:itens-selecionados="filtros.produtoresSelecionados"
            :configuracao-busca="configBuscaProdutor"
            placeholder="Nome ou CNPJ..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroDocumentosEntrada"
            label="Documentos de Entrada"
            v-model="filtros.idsDocumentosEntrada"
            v-model:itens-selecionados="filtros.documentosEntradaSelecionados"
            :configuracao-busca="configBuscaDocumentoEntrada"
            placeholder="Nº Documento..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroFiliais"
            label="Filiais"
            v-model="filtros.idsFiliais"
            v-model:itens-selecionados="filtros.filiaisSelecionados"
            :configuracao-busca="configBuscaFilial"
            placeholder="Selecione filiais..."
          />
        </div>
        <div class="col-md-4">
          <CampoBuscaMultiplo
            id="filtroLocaisEstoque"
            label="Locais de Estoque"
            v-model="filtros.idsLocaisEstoque"
            v-model:itens-selecionados="filtros.locaisEstoqueSelecionados"
            :configuracao-busca="configBuscaLocalEstoque"
            placeholder="Selecione locais..."
            @show-notification="emitNotification"
          />
        </div>
        <div class="col-md-3">
          <CampoBuscaLista
            id="lstTipoLocal"
            label="Tipo de Local"
            tabela="LocalEstoque"
            v-model="filtros.lstTipoLocal"
          />
        </div>
        <div class="col-md-3">
          <div class="d-flex gap-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkOcultarZero" v-model="filtros.ocultarSaldoZero">
              <label class="form-check-label" for="chkOcultarZero">Ocultar saldo zero</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkApenasDisponivel" v-model="filtros.apenasDisponivel">
              <label class="form-check-label" for="chkApenasDisponivel">Só disponível</label>
            </div>
          </div>
          <div class="form-text mt-1 mb-3 invisible">&nbsp;</div>
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-secondary me-2" @click="limparFiltros">Limpar</button>
          <button class="btn btn-primary" @click="aplicarFiltros">Aplicar Filtros</button>
        </div>
      </div>
    </template>

    <div v-if="erro" class="alert alert-danger m-3 border-0 d-flex align-items-center">
      <i class="bi bi-exclamation-triangle-fill fs-4 me-3"></i> {{ erro }}
    </div>

    <div v-if="!erro" class="row g-3 mb-3 px-3">
      <div class="col-md-3">
        <div class="card border-0 shadow-sm bg-primary bg-opacity-10 h-100">
          <div class="card-body text-center py-3">
            <div class="fs-4 fw-bold">{{ formatarNumero(resumo.totalItens, 0) }}</div>
            <small class="text-muted">Itens em Estoque</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 shadow-sm bg-success bg-opacity-10 h-100">
          <div class="card-body text-center py-3">
            <div class="fs-4 fw-bold">{{ formatarNumero(resumo.totalQtdEstoque, 4) }}</div>
            <small class="text-muted">Qtd Total em Estoque</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 shadow-sm bg-warning bg-opacity-10 h-100">
          <div class="card-body text-center py-3">
            <div class="fs-4 fw-bold">{{ formatarMoeda(resumo.totalValorPadrao) }}</div>
            <small class="text-muted">Valor Total (BRL)</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 shadow-sm bg-info bg-opacity-10 h-100">
          <div class="card-body text-center py-3">
            <div class="fs-4 fw-bold">{{ formatarMoedaGerencial(resumo.totalValorGerencial) }}</div>
            <small class="text-muted">Valor Total (USD)</small>
          </div>
        </div>
      </div>
    </div>

    <AdminTable
      v-if="!erro"
      ref="adminTableRef"
      :columns="colunas"
      :data="lista"
      :loading="loading"
      empty-message="Nenhum saldo especial encontrado."
      row-key="idSaldoEstoqueOrigem"
      v-model:sort-field="sortField"
      v-model:sort-order="sortOrder"
      modulo-layout="SaldosEstoqueOrigem"
      :colunas-padrao="colunasPadrao"
      :bloquear-primeira-coluna="false"
      :colunas-fixas="['skuProduto']"
      :exportando-progresso="exportandoProgresso"
      :dados-exportar="dadosExportar"
      titulo-exportacao="Saldo Estoque - Especiais"
      :filtros-exportacao="descricaoFiltros"
      @sort-change="handleSortChange"
      @show-notification="emitNotification"
      @exportar-dados="handleExportarDados"
      @group-by-changed="onGroupByChanged"
    >
      <template #skuProduto="{ row }">
        <span class="fw-bold text-danger small">{{ row.skuProduto || '-' }}</span>
      </template>
      <template #nomeProduto="{ row }">
        <span class="fw-medium text-body-emphasis">{{ row.nomeProduto || '-' }}</span>
      </template>
      <template #numeroContratoFornecedor="{ row }">
        <span class="fw-medium">{{ row.numeroContratoFornecedor || '-' }}</span>
      </template>
      <template #nomeFornecedorContrato="{ row }">
        {{ row.nomeFornecedorContrato || '-' }}
      </template>
      <template #nomeReferenciaCota="{ row }">
        {{ row.nomeReferenciaCota || '-' }}
      </template>
      <template #numeroDocumentoEntrada="{ row }">
        <span class="fw-medium">{{ row.numeroDocumentoEntrada || '-' }}</span>
      </template>
      <template #nomeFornecedorDocEntrada="{ row }">
        {{ row.nomeFornecedorDocEntrada || '-' }}
      </template>
      <template #nomeProdutor="{ row }">
        {{ row.nomeProdutor || '-' }}
      </template>
      <template #numeroProcessoEmbarque="{ row }">
        <span class="fw-medium">{{ row.numeroProcessoEmbarque || '-' }}</span>
      </template>
      <template #numeroDocumentoTransporte="{ row }">
        {{ row.numeroDocumentoTransporte || '-' }}
      </template>
      <template #nomeFilial="{ row }">
        {{ row.nomeFilial || '-' }}
      </template>
      <template #nomeLocalEstoque="{ row }">
        {{ row.nomeLocalEstoque || '-' }}
      </template>
      <template #lstTipoLocal="{ row }">
        <span class="badge badge-ghost-secondary">{{ getTextoLista('LstTipoLocal', row.lstTipoLocal) }}</span>
      </template>
      <template #quantidadeDisponivel="{ row }">
        <span class="badge" :class="badgeClasseDisponivel(row)">{{ formatarNumero(row.quantidadeDisponivel, 4) }}</span>
      </template>
      <template #numeroLoteFornecedor="{ row }">
        {{ row.numeroLoteFornecedor || '-' }}
      </template>
      <template #dataFabricacao="{ row }">
        {{ row.dataFabricacao ? formatarDataBR(row.dataFabricacao) : '-' }}
      </template>
      <template #dataValidade="{ row }">
        {{ row.dataValidade ? formatarDataBR(row.dataValidade) : '-' }}
      </template>
      <template #lstUnidadeMedidaBase="{ row }">
        <span class="badge badge-ghost-secondary">{{ getTextoLista('LstUnidadeMedidaBase', row.lstUnidadeMedidaBase) }}</span>
      </template>
    </AdminTable>
  </PaginaAdministrar>
</template>

<script setup>
import { ref, reactive, computed, nextTick, onMounted, onActivated, watch } from 'vue'
import api from '@/services/api'
import { useAuthStore } from '@/stores/auth'
import { useMetadataListasStore } from '@/stores/metadataListas'
import { usePaginacao } from '@/composables/usePaginacao'
import PaginaAdministrar from '@/components/base/grid/PaginaAdministrar.vue'
import AdminTable from '@/components/base/grid/AdminTable.vue'
import CampoBuscaMultiplo from '@/components/base/campos/CampoBuscaMultiplo.vue'
import CampoBuscaLista from '@/components/base/campos/CampoBuscaLista.vue'
import { criarConfigBuscaProduto } from '@/search-definitions/produtoSearch'
import { ST } from '@/constants/ST'
import { PROD_NATUREZA } from '@/constants/PROD_NATUREZA'
import { criarConfigBuscaContrato } from '@/search-definitions/contratoSearch'
import { criarConfigBuscaPurchaseOrder } from '@/search-definitions/purchaseOrderSearch'
import { criarConfigBuscaEmbarque } from '@/search-definitions/embarqueSearch'
import { criarConfigBuscaDocumentoEntrada } from '@/search-definitions/documentoEntradaSearch'
import { criarConfigBuscaProdutor } from '@/search-definitions/produtorSearch'
import { fornecedorSearch } from '@/search-definitions/fornecedorSearch'
import { filialSearch } from '@/search-definitions/filialSearch'
import { criarConfigBuscaLocalEstoque } from '@/search-definitions/localEstoqueSearch'
import { formatarDataBR, formatarDataHoraBR } from '@/utils/useDataBR'

const emit = defineEmits(['show-notification', 'visualizar-item'])
const authStore = useAuthStore()
const metadataStore = useMetadataListasStore()
const { paginacao, injetarParametros, atualizarPaginacao } = usePaginacao(25)

const emitNotification = (p) => emit('show-notification', p)

// ============================================================
// Mapeamento Dimensional: campo descritivo → groupKey do backend
// ============================================================
const dimensaoParaGroupKey = {
  skuProduto: 'idProduto',
  nomeProduto: 'idProduto',
  codigoNcm: 'idProduto',
  lstUnidadeMedidaBase: 'idProduto',
  nomeFilial: 'idFilial',
  idFilial: 'idFilial',
  nomeLocalEstoque: 'idLocalEstoque',
  idLocalEstoque: 'idLocalEstoque',
  lstTipoLocal: 'idLocalEstoque',
  idCotaCompra: 'idCotaCompra',
  numeroDocumentoEntrada: 'idDocumentoEntrada',
  serieDocumento: 'idDocumentoEntrada',
  nomeFornecedorDocEntrada: 'idParceiroNegocioFornecedorDoc',
  dataEmissaoDocumento: 'idDocumentoEntrada',
  idDocumentoEntrada: 'idDocumentoEntrada',
  numeroProcessoEmbarque: 'idEmbarque',
  numeroDocumentoTransporte: 'idEmbarque',
  numeroBooking: 'idEmbarque',
  lstModalTransporte: 'idEmbarque',
  lstPaisOrigem: 'idEmbarque',
  lstPortoOrigem: 'idEmbarque',
  lstIncoterm: 'idEmbarque',
  nomeVeiculoTransporte: 'idEmbarque',
  numeroViagem: 'idEmbarque',
  dataEmbarqueETD: 'idEmbarque',
  dataChegadaETA: 'idEmbarque',
  idEmbarquePackingListProduto: 'idEmbarquePackingListProduto',
  nomeProdutor: 'idParceiroNegocioProdutor',
  documentoProdutor: 'idParceiroNegocioProdutor',
  numeroLoteFornecedor: 'idLoteFabricacao',
  dataFabricacao: 'idLoteFabricacao',
  dataValidade: 'idLoteFabricacao',
  idLoteFabricacao: 'idLoteFabricacao'
}

// ============================================================
// Estado
// ============================================================
const lista = ref([])
const loading = ref(false)
const erro = ref(null)
const filtrosAbertos = ref(false)
const listas = reactive({})
const isLoadingListas = ref(false)

// Controle de concorrência: cancela requisição anterior se uma nova for disparada
let abortController = null

const exportandoProgresso = ref({ total: 0, carregados: 0 })
const dadosExportar = ref(null)

const sortField = ref('')
const sortOrder = ref('desc')
const groupByFields = ref([])
const adminTableRef = ref(null)

// Quando os campos visíveis mudam, calcula o groupBy automaticamente
function onGroupByChanged ({ visibleFields }) {
  const campos = new Set()
  for (const field of visibleFields) {
    const groupKey = dimensaoParaGroupKey[field]
    if (groupKey) campos.add(groupKey)
  }
  groupByFields.value = [...campos]
  buscarDados(1)
}

const filtros = reactive({
  idsProdutos: [],
  produtosSelecionados: [],
  idsContratos: [],
  contratosSelecionados: [],
  idsPurchaseOrders: [],
  purchaseOrdersSelecionados: [],
  idsEmbarques: [],
  embarquesSelecionados: [],
  idsFornecedores: [],
  fornecedoresSelecionados: [],
  idsProdutores: [],
  produtoresSelecionados: [],
  idsFiliais: [],
  filiaisSelecionados: [],
  idsLocaisEstoque: [],
  locaisEstoqueSelecionados: [],
  idsDocumentosEntrada: [],
  documentosEntradaSelecionados: [],
  lstTipoLocal: '',
  ocultarSaldoZero: false,
  apenasDisponivel: false
})

const resumo = reactive({
  totalItens: 0,
  totalQtdEstoque: 0,
  totalValorPadrao: 0,
  totalValorGerencial: 0
})

// ============================================================
// Colunas
// ============================================================
const colunasPadrao = [
  // Grupo 1 — Produto
  { field: 'skuProduto', label: 'SKU', width: 120, sortable: true, align: 'left' },
  { field: 'nomeProduto', label: 'Nome do Produto', width: 220, sortable: true, align: 'left' },
  { field: 'codigoNcm', label: 'NCM', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'lstUnidadeMedidaBase', label: 'Unidade de Medida Básica', width: 120, sortable: false, align: 'left' },

  // Grupo 2 — Origem Contratual
  { field: 'nomeReferenciaCota', label: 'Cota/Referência', width: 150, sortable: false, align: 'left' },
  { field: 'idCotaCompra', label: 'ID Cota', width: 100, sortable: false, align: 'left', visible: false },

  // Grupo 3 — Documento de Entrada
  { field: 'numeroDocumentoEntrada', label: 'Nº Documento Legal', width: 140, sortable: false, align: 'left' },
  { field: 'idDocumentoEntrada', label: 'ID Documento Entrada', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'serieDocumento', label: 'Série', width: 70, sortable: false, align: 'center', visible: false },
  {
    field: 'dataEmissaoDocumento',
    label: 'Data Emissão do Documento',
    width: 140,
    sortable: false,
    align: 'center',
    formatter: (val) => val ? formatarDataBR(val) : '-'
  },
  { field: 'nomeFornecedorDocEntrada', label: 'Fornecedor (Doc.)', width: 180, sortable: false, align: 'left' },
  { field: 'nomeProdutor', label: 'Produtor', width: 180, sortable: false, align: 'left' },

  // Grupo 4 — Embarque
  { field: 'numeroProcessoEmbarque', label: 'Nº Processo Embarque', width: 150, sortable: false, align: 'left' },
  { field: 'idEmbarquePackingListProduto', label: 'ID Packing List', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'numeroDocumentoTransporte', label: 'Nº Doc. Transporte', width: 140, sortable: false, align: 'left' },
  { field: 'numeroBooking', label: 'Booking', width: 120, sortable: false, align: 'left', visible: false },
  { field: 'lstModalTransporte', label: 'Modal', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'lstPaisOrigem', label: 'País Origem', width: 120, sortable: false, align: 'left', visible: false },
  { field: 'lstPortoOrigem', label: 'Porto Origem', width: 120, sortable: false, align: 'left', visible: false },
  { field: 'lstIncoterm', label: 'Incoterm', width: 100, sortable: false, align: 'left', visible: false },
  {
    field: 'dataEmbarqueETD',
    label: 'ETD',
    width: 100,
    sortable: false,
    align: 'center',
    formatter: (val) => val ? formatarDataBR(val) : '-',
    visible: false
  },
  {
    field: 'dataChegadaETA',
    label: 'ETA',
    width: 100,
    sortable: false,
    align: 'center',
    formatter: (val) => val ? formatarDataBR(val) : '-',
    visible: false
  },

  // Grupo 5 — Localização
  { field: 'idFilial', label: 'ID Filial', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'nomeFilial', label: 'Filial', width: 150, sortable: true, align: 'left' },
  { field: 'idLocalEstoque', label: 'ID Local Estoque', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'nomeLocalEstoque', label: 'Local de Estoque', width: 170, sortable: true, align: 'left' },
  { field: 'lstTipoLocal', label: 'Tipo do Local', width: 130, sortable: false, align: 'center' },

  // Grupo 6 — Quantidades
  {
    field: 'quantidadeEmEstoque',
    label: 'Qtd em Estoque',
    width: 120,
    sortable: true,
    align: 'right',
    formatter: (val) => formatarNumero(val, 4)
  },
  {
    field: 'quantidadeDisponivel',
    label: 'Qtd Disponível',
    width: 120,
    sortable: true,
    align: 'right',
    formatter: (val) => formatarNumero(val, 4)
  },
  {
    field: 'quantidadeReservada',
    label: 'Qtd Reservada',
    width: 120,
    sortable: true,
    align: 'right',
    formatter: (val) => formatarNumero(val, 4)
  },

  // Grupo 7 — Volumes
  {
    field: 'quantidadeVolumesEmEstoque',
    label: 'Qtd Volumes Estoque',
    width: 120,
    sortable: false,
    align: 'right',
    formatter: (val) => val != null ? formatarNumero(val, 0) : '-',
    visible: false
  },
  {
    field: 'quantidadeVolumesDisponivel',
    label: 'Qtd Volumes Disponível',
    width: 120,
    sortable: false,
    align: 'right',
    formatter: (val) => val != null ? formatarNumero(val, 0) : '-',
    visible: false
  },
  {
    field: 'quantidadeVolumesReservada',
    label: 'Qtd Volumes Reservada',
    width: 120,
    sortable: false,
    align: 'right',
    formatter: (val) => val != null ? formatarNumero(val, 0) : '-',
    visible: false
  },

  // Grupo 8 — Lote
  { field: 'idLoteFabricacao', label: 'ID Lote Fabricação', width: 100, sortable: false, align: 'left', visible: false },
  { field: 'numeroLoteFornecedor', label: 'Nº Lote Fornecedor', width: 130, sortable: false, align: 'left' },
  {
    field: 'dataFabricacao',
    label: 'Data de Fabricação (Lote Fabric.)',
    width: 130,
    sortable: false,
    align: 'center',
    formatter: (val) => val ? formatarDataBR(val) : '-'
  },
  {
    field: 'dataValidade',
    label: 'Data de Validade (Lote Fabric.)',
    width: 130,
    sortable: false,
    align: 'center',
    formatter: (val) => val ? formatarDataBR(val) : '-'
  },

  // Grupo 9 — Custos
  {
    field: 'custoUnitOrigemPadrao',
    label: 'Custo Unitário (BRL)',
    width: 150,
    sortable: true,
    align: 'right',
    formatter: (val) => val != null ? formatarNumero(val, 6) : '-'
  },
  {
    field: 'custoUnitOrigemGerencial',
    label: 'Custo Unitário (USD)',
    width: 150,
    sortable: true,
    align: 'right',
    formatter: (val) => val != null ? formatarNumero(val, 6) : '-',
    visible: false
  },

  // Grupo 10 — Auditoria
  {
    field: 'tsModificacao',
    label: 'Data Modificação do Registro',
    width: 160,
    sortable: true,
    align: 'center',
    formatter: (val) => val ? formatarDataHoraBR(new Date(val)) : '-'
  }
]

const campoSlotMap = {
  skuProduto: 'skuProduto',
  nomeProduto: 'nomeProduto',
  numeroContratoFornecedor: 'numeroContratoFornecedor',
  nomeFornecedorContrato: 'nomeFornecedorContrato',
  nomeReferenciaCota: 'nomeReferenciaCota',
  numeroDocumentoEntrada: 'numeroDocumentoEntrada',
  nomeFornecedorDocEntrada: 'nomeFornecedorDocEntrada',
  nomeProdutor: 'nomeProdutor',
  numeroProcessoEmbarque: 'numeroProcessoEmbarque',
  numeroDocumentoTransporte: 'numeroDocumentoTransporte',
  nomeFilial: 'nomeFilial',
  nomeLocalEstoque: 'nomeLocalEstoque',
  lstTipoLocal: 'lstTipoLocal',
  quantidadeDisponivel: 'quantidadeDisponivel',
  numeroLoteFornecedor: 'numeroLoteFornecedor',
  dataFabricacao: 'dataFabricacao',
  dataValidade: 'dataValidade',
  lstUnidadeMedidaBase: 'lstUnidadeMedidaBase'
}

const colunas = computed(() => {
  return colunasPadrao.map(c => ({
    ...c,
    slotName: campoSlotMap[c.field] || undefined
  }))
})

// ============================================================
// Configurações de busca
// ============================================================
const configBuscaProduto = computed(() => {
  const base = criarConfigBuscaProduto(ST.Ativo, PROD_NATUREZA.ProdutoFisico)
  return {
    ...base,
    titulo: 'Buscar Produto',
    filtrosFixos: { ...base.filtrosFixos, idEmpresa: authStore.empresaAtiva }
  }
})

const configBuscaContrato = computed(() => ({
  ...criarConfigBuscaContrato(authStore.organizacaoAtiva),
  titulo: 'Buscar Contrato'
}))

const configBuscaPurchaseOrder = computed(() => ({
  ...criarConfigBuscaPurchaseOrder(authStore.organizacaoAtiva),
  titulo: 'Buscar Purchase Order'
}))

const configBuscaEmbarque = computed(() => ({
  ...criarConfigBuscaEmbarque(authStore.organizacaoAtiva),
  titulo: 'Buscar Embarque'
}))

const configBuscaDocumentoEntrada = computed(() => ({
  ...criarConfigBuscaDocumentoEntrada(authStore.organizacaoAtiva),
  titulo: 'Buscar Documento de Entrada'
}))

const configBuscaProdutor = computed(() => ({
  ...criarConfigBuscaProdutor(authStore.organizacaoAtiva),
  titulo: 'Buscar Produtor'
}))

const configBuscaFornecedor = computed(() => ({
  ...fornecedorSearch,
  titulo: 'Buscar Fornecedor',
  filtrosFixos: { idEmpresa: authStore.empresaAtiva, isFornecedor: true }
}))

const configBuscaFilial = computed(() => ({
  ...filialSearch,
  titulo: 'Buscar Filial',
  filtrosFixos: { idEmpresa: authStore.empresaAtiva }
}))

const configBuscaLocalEstoque = computed(() => {
  // Correlação com o filtro de Filiais (múltiplo): só fixa a filial quando houver
  // exatamente UMA selecionada. Com múltiplas (ou nenhuma), NÃO restringe por filial,
  // para não esconder os locais das demais filiais selecionadas.
  // Tipos de local: [] = mostra todos (a consulta de Saldos não deve restringir a Trânsito).
  const base = criarConfigBuscaLocalEstoque(
    authStore.organizacaoAtiva,
    filtros.idsFiliais?.length === 1 ? filtros.idsFiliais[0] : undefined,
    []
  )
  return { ...base, titulo: 'Buscar Local de Estoque' }
})

// ============================================================
// Busca de dados
// ============================================================
async function buscarDados (pageNumber = 1) {
  if (authStore.isAdminInterno && !authStore.empresaAtiva) {
    erro.value = 'Por favor, selecione uma Empresa no topo da página.'
    lista.value = []
    return
  }

  // Cancela requisição anterior ainda em andamento para evitar race condition
  if (abortController) {
    abortController.abort()
  }
  abortController = new AbortController()

  loading.value = true
  erro.value = null

  try {
    const isAgrupado = groupByFields.value.length > 0
    const params = new URLSearchParams()

    if (isAgrupado) {
      params.append('groupBy', groupByFields.value.join(','))
    } else {
      const pagParams = injetarParametros(pageNumber)
      for (const [k, v] of pagParams.entries()) params.append(k, v)
    }

    if (authStore.empresaAtiva) params.append('idEmpresa', authStore.empresaAtiva)
    if (filtros.idsProdutos.length > 0) params.append('idsProdutos', filtros.idsProdutos.join(','))
    if (filtros.idsContratos.length > 0) params.append('idsContratos', filtros.idsContratos.join(','))
    if (filtros.idsPurchaseOrders.length > 0) params.append('idsCotas', filtros.idsPurchaseOrders.join(','))
    if (filtros.idsEmbarques.length > 0) params.append('idsEmbarquesFiltro', filtros.idsEmbarques.join(','))
    if (filtros.idsFornecedores.length > 0) params.append('idsFornecedores', filtros.idsFornecedores.join(','))
    if (filtros.idsProdutores.length > 0) params.append('idsProdutoresFiltro', filtros.idsProdutores.join(','))
    if (filtros.idsFiliais.length > 0) params.append('idsFiliais', filtros.idsFiliais.join(','))
    if (filtros.idsLocaisEstoque.length > 0) params.append('idsLocaisEstoque', filtros.idsLocaisEstoque.join(','))
    if (filtros.idsDocumentosEntrada.length > 0) params.append('idsDocumentosEntrada', filtros.idsDocumentosEntrada.join(','))
    if (filtros.lstTipoLocal) params.append('lstTipoLocal', filtros.lstTipoLocal)
    if (filtros.ocultarSaldoZero) params.append('ocultarSaldoZero', 'true')
    if (filtros.apenasDisponivel) params.append('apenasDisponivel', 'true')
    if (sortField.value) params.append('sortBy', sortField.value)
    if (sortOrder.value) params.append('sortOrder', sortOrder.value)

    const endpoint = isAgrupado ? '/SaldosEstoqueOrigem/agrupado' : '/SaldosEstoqueOrigem'
    const response = await api.get(`${endpoint}?${params.toString()}`, {
      signal: abortController.signal
    })
    lista.value = response.data
    if (!isAgrupado) {
      atualizarPaginacao(response.headers)
      await carregarResumo()
    } else {
      paginacao.value.TotalCount = response.data.length
    }
  } catch (error) {
    // Ignora erros de requisição cancelada (race condition controlada)
    if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') return
    erro.value = 'Não foi possível carregar os dados.'
    lista.value = []
    paginacao.value.TotalCount = 0
  } finally {
    loading.value = false
  }
}

async function carregarResumo () {
  try {
    const params = new URLSearchParams()
    if (authStore.empresaAtiva) params.append('idEmpresa', authStore.empresaAtiva)
    if (filtros.idsProdutos.length > 0) params.append('idsProdutos', filtros.idsProdutos.join(','))
    if (filtros.idsContratos.length > 0) params.append('idsContratos', filtros.idsContratos.join(','))
    if (filtros.idsPurchaseOrders.length > 0) params.append('idsCotas', filtros.idsPurchaseOrders.join(','))
    if (filtros.idsEmbarques.length > 0) params.append('idsEmbarquesFiltro', filtros.idsEmbarques.join(','))
    if (filtros.idsFornecedores.length > 0) params.append('idsFornecedores', filtros.idsFornecedores.join(','))
    if (filtros.idsProdutores.length > 0) params.append('idsProdutoresFiltro', filtros.idsProdutores.join(','))
    if (filtros.idsFiliais.length > 0) params.append('idsFiliais', filtros.idsFiliais.join(','))
    if (filtros.idsLocaisEstoque.length > 0) params.append('idsLocaisEstoque', filtros.idsLocaisEstoque.join(','))
    if (filtros.idsDocumentosEntrada.length > 0) params.append('idsDocumentosEntrada', filtros.idsDocumentosEntrada.join(','))
    if (filtros.lstTipoLocal) params.append('lstTipoLocal', filtros.lstTipoLocal)
    if (filtros.ocultarSaldoZero) params.append('ocultarSaldoZero', 'true')
    if (filtros.apenasDisponivel) params.append('apenasDisponivel', 'true')

    const response = await api.get(`/SaldosEstoqueOrigem/resumo?${params.toString()}`)
    Object.assign(resumo, response.data || {})
  } catch (e) {
    console.error('[EstoqueSaldosOrigem] Erro ao carregar resumo:', e)
  }
}

// ============================================================
// Exportação
// ============================================================
async function handleExportarDados () {
  if (!authStore.empresaAtiva) {
    emitNotification({ message: 'Selecione uma empresa antes de exportar.', type: 'warning' })
    return
  }

  const totalRegistros = paginacao.value.totalCount ?? paginacao.value.TotalCount ?? 0
  if (!totalRegistros) {
    emitNotification({ message: 'Nenhum dado para exportar.', type: 'warning' })
    return
  }

  exportandoProgresso.value = { total: totalRegistros, carregados: 0 }
  dadosExportar.value = null

  const pageSize = paginacao.value.PageSize || 25
  const totalPages = Math.ceil(totalRegistros / pageSize)
  let todosDados = []

  try {
    for (let page = 1; page <= totalPages; page++) {
      const params = new URLSearchParams()
      params.append('pageNumber', page)
      params.append('pageSize', pageSize)
      if (authStore.empresaAtiva) params.append('idEmpresa', authStore.empresaAtiva)
      if (filtros.idsProdutos.length > 0) params.append('idsProdutos', filtros.idsProdutos.join(','))
      if (filtros.idsContratos.length > 0) params.append('idsContratos', filtros.idsContratos.join(','))
      if (filtros.idsPurchaseOrders.length > 0) params.append('idsCotas', filtros.idsPurchaseOrders.join(','))
      if (filtros.idsEmbarques.length > 0) params.append('idsEmbarquesFiltro', filtros.idsEmbarques.join(','))
      if (filtros.idsFornecedores.length > 0) params.append('idsFornecedores', filtros.idsFornecedores.join(','))
      if (filtros.idsProdutores.length > 0) params.append('idsProdutoresFiltro', filtros.idsProdutores.join(','))
      if (filtros.idsFiliais.length > 0) params.append('idsFiliais', filtros.idsFiliais.join(','))
      if (filtros.idsLocaisEstoque.length > 0) params.append('idsLocaisEstoque', filtros.idsLocaisEstoque.join(','))
      if (filtros.idsDocumentosEntrada.length > 0) params.append('idsDocumentosEntrada', filtros.idsDocumentosEntrada.join(','))
      if (filtros.lstTipoLocal) params.append('lstTipoLocal', filtros.lstTipoLocal)
      if (filtros.ocultarSaldoZero) params.append('ocultarSaldoZero', 'true')
      if (filtros.apenasDisponivel) params.append('apenasDisponivel', 'true')
      if (sortField.value) params.append('sortBy', sortField.value)
      if (sortOrder.value) params.append('sortOrder', sortOrder.value)

      const response = await api.get(`/SaldosEstoqueOrigem?${params.toString()}`)
      const dados = response.data
      if (Array.isArray(dados)) todosDados = todosDados.concat(dados)
      exportandoProgresso.value = { total: totalRegistros, carregados: todosDados.length }
    }

    dadosExportar.value = [...todosDados]
    await nextTick()
    exportandoProgresso.value = { total: 0, carregados: 0 }
  } catch (e) {
    console.error('[EstoqueSaldosOrigem] Erro na exportação:', e)
    emitNotification({ message: 'Erro ao coletar dados para exportação.', type: 'error' })
    exportandoProgresso.value = { total: 0, carregados: 0 }
  }
}

// ============================================================
// Ações
// ============================================================
const aplicarFiltros = () => buscarDados(1)
const limparFiltros = () => {
  filtros.idsProdutos = []; filtros.produtosSelecionados = []
  filtros.idsContratos = []; filtros.contratosSelecionados = []
  filtros.idsPurchaseOrders = []; filtros.purchaseOrdersSelecionados = []
  filtros.idsEmbarques = []; filtros.embarquesSelecionados = []
  filtros.idsFornecedores = []; filtros.fornecedoresSelecionados = []
  filtros.idsProdutores = []; filtros.produtoresSelecionados = []
  filtros.idsFiliais = []; filtros.filiaisSelecionados = []
  filtros.idsLocaisEstoque = []; filtros.locaisEstoqueSelecionados = []
  filtros.idsDocumentosEntrada = []; filtros.documentosEntradaSelecionados = []
  filtros.lstTipoLocal = ''
  filtros.ocultarSaldoZero = false
  filtros.apenasDisponivel = false
  buscarDados(1)
}
const mudarPagina = (page) => {
  if (page >= 1 && page <= (paginacao.value.TotalPages || 1)) buscarDados(page)
}
const mudarTamanhoPagina = (n) => { paginacao.value.PageSize = n; buscarDados(1) }
const handleSortChange = () => buscarDados(1)

// ============================================================
// Formatação
// ============================================================
function formatarNumero (valor, decimais = 2) {
  if (valor === null || valor === undefined) return '-'
  return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: decimais, maximumFractionDigits: decimais })
}
function formatarMoeda (valor) {
  if (valor === null || valor === undefined) return '-'
  return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
function formatarMoedaGerencial (valor) {
  if (valor === null || valor === undefined) return '-'
  return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'USD' })
}
function badgeClasseDisponivel (row) {
  if (row.quantidadeDisponivel > 0) return 'badge-ghost-success'
  if (row.quantidadeEmEstoque > 0) return 'badge-ghost-warning'
  if (row.quantidadeEmEstoque === 0) return 'badge-ghost-secondary'
  return 'badge-ghost-danger'
}

// ============================================================
// Resolução de Listas (Lst*)
// ============================================================
function getTextoLista (listaKey, id) {
  if (!id) return '-'
  const lista = listas[listaKey] || []
  const item = lista.find(i =>
    String(i.idListaSistemaItem) === String(id) ||
    String(i.idListaClienteItem) === String(id)
  )
  return item ? item.textoLista : id
}

const carregarListas = async () => {
  isLoadingListas.value = true
  try {
    const result = await metadataStore.carregarListasParaTabelas(['LocalEstoque', 'Produto'])
    Object.assign(listas, result)
  } catch (error) {
    console.error('Erro ao carregar listas auxiliares:', error)
  } finally {
    isLoadingListas.value = false
  }
}

// ============================================================
// Ciclo de vida
// ============================================================
watch(() => authStore.empresaAtiva, async (n) => {
  if (n) {
    await carregarListas()
    buscarDados(1)
  } else {
    lista.value = []
    paginacao.value.TotalCount = 0
    Object.keys(listas).forEach(k => delete listas[k])
  }
})

onMounted(async () => {
  if (authStore.empresaAtiva || !authStore.isAdminInterno) {
    await carregarListas()
    buscarDados(1)
  }
})

onActivated(() => {
  buscarDados(paginacao.value.CurrentPage || 1)
})
</script>

<style scoped>
</style>
